module.exports = __webpack_public_path__ + "img/nuCypher.243c6d47.png";